import React from 'react';
import {useIntl} from 'react-intl';

import {EditorWrapper} from './wrapper';

export const CanPostOnlyInChannel = () => {
    const {formatMessage} = useIntl();

    return (
        <EditorWrapper>
            {formatMessage({
                id: 'editor_state.can_post_only_in_channel',
                defaultMessage: 'The thread is read-only',
            })}
        </EditorWrapper>
    );
};
